const team_puo = 0;
const team_toezichthouder = 1;
const team_media = 2;

const game = {
    kccEnabled: true,
    portalEnabled: true,
    // 0 = the start, around 23b is completed, game finished.
    progress: 0,
    inbox: [
        // Minimal fallback entry for when no dynamic content is available
        { 
            id: 'no-scenario', 
            dilemmaId: "no-scenario", 
            teams: [team_puo, team_media, team_toezichthouder], 
            subject: "Geen scenario actief", 
            from: 'systeem@vtw.nl', 
            sender: 'Systeem', 
            receiver: 'Bestuur', 
            isRead: true, 
            visible: true, 
            type: 'email', 
            important: false, 
            avatar: 'ic_avatar.svg' 
        }
    ],
    websiteMessages: [
        // Empty - will be populated by dynamic scenarios
    ],
    phonebook: [
        // Minimal phonebook entries
        {
            name: 'VTW Support',
            role: 'Ondersteuning',
            phone: '0800-VTW-HELP',
            isDynamic: false,
        },
        {
            name: 'Spelleider',
            role: 'Begeleiding',
            phone: '0800-GAME-LEAD',
            isDynamic: false,
        }
    ]
};

module.exports = { game, team_puo, team_toezichthouder, team_media };